import React from 'react';
import { Box, InputBase } from '@mui/material';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { palette } from '../theme/colors';

export interface ProductSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export const ProductSearch: React.FC<ProductSearchProps> = ({
  value,
  onChange,
  placeholder = 'Search products...',
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        bgcolor: palette.sky,
        borderRadius: 50,
        px: 2,
        py: 0.5,
        width: { xs: '100%', sm: 'auto' },
        minWidth: 200,
      }}
    >
      <SearchOutlinedIcon sx={{ color: palette.textMuted, fontSize: 20, mr: 1 }} />
      <InputBase
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        sx={{
          flex: 1,
          fontSize: '0.875rem',
          '& input': { p: 0.5 },
        }}
      />
    </Box>
  );
};
